import { useState } from "react";
import PasswordStrengthBar from "react-password-strength-bar";

export function InputField({ isRequired, type, withIcon, onChange, placeholder, defaultValue, name, id, showStrength, label, compareStrength }) {

    const [seePassword, setSeePassword ] = useState(false);


    return (
        <div className="mb-3">
            <div className="mb-2 relative">
                {label && <label className="text-sm font-fira font-normal" htmlFor={id}>{label} {isRequired && <span className="text-red-800 font-bold">*</span>}</label>}
                <input
                    type={seePassword ? 'text' : type}
                    placeholder={placeholder}
                    name={name} id={id}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    className={`w-full py-3 mt-1 text-xs border-2 border-gray-300 rounded-lg focus:outline-blue-800 ${withIcon? 'pl-8 pr-4': 'px-4'}`}
                /> 
                

                {type === 'password' && <span onClick={() => setSeePassword(!seePassword)} className="absolute bottom-3 right-5">
                    {!seePassword && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 text-gray-500 h-5">
                        <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                        <path fillRule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clipRule="evenodd" />
                    </svg>}

                    {seePassword && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 text-gray-500 h-5">
                        <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                        <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                        <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                    </svg>}
                </span>}

                
            </div>
            {(type === 'password' && showStrength) && <PasswordStrengthBar style={{
                fontSize: "11px",
            }} className="text-xs font-semibold mx-6 animate__animated animate__zoomInUp" password={compareStrength} />}

        </div>
    )  
}


export default function SelectInputField({ isRequired, label, options, id, name, defaultValue, onChange, placeholder}) {
  return (
    <div className="mb-3">
        <div className="mb-2 relative">
            {label && <label className="text-sm font-fira font-normal" htmlFor={id}>{label} {isRequired && <span className="text-red-800 font-bold">*</span>}</label>}
            <input defaultValue={defaultValue} autoComplete="off" className="w-full py-3 px-4 mt-1 text-xs border-2 border-gray-300 rounded-lg appearance-none focus:outline-blue-800" list={`${id}-list`} name={name} onChange={onChange}  placeholder={placeholder} />
            <datalist id={`${id}-list`} className="h-40 w-full rounded-lg bg-white ">
                {options.map((op) => (<option value={op} key={op}> {op} </option>) ) }
            </datalist>
        </div>
    </div>
  )
}

export function SelectOptionField({ isRequired, label, options, id, name, defaultValue, onChange, placeholder }) {
    return (
        <div className="mb-3">
            <div className="mb-2 relative">
                {label && <label className="text-sm capitalize font-fira font-normal" htmlFor={id}>{label} {isRequired && <span className="text-red-800 font-bold">*</span>}</label>}
                <select onChange={onChange} autoComplete="off" defaultValue={defaultValue} className="w-full py-3 px-4 mt-1 text-xs border-2 border-gray-300 rounded-lg appearance-none focus:outline-blue-800" list={`${id}-list`} name={name} placeholder={placeholder}>
                    {options.map((op) => (<option value={op} className="capitalize" key={op}> {op} </option>))}
                </select>
            </div>
        </div>
    )
}


export function FileInput({ isRequired, value, label, name, id, fileType, onChange, multiple}) {

  return (
    <div className="mb-3 cursor-pointer">
      <label htmlFor={id} className="mb-2">
          <div className="upload-button cursor-pointer text-sm hover:border-blue-800 text-gray-800 hover:text-blue-800 focus:text-blue-800 focus:border-blue-800 transition delay-300 ease-in-out font-semibold gap-4 justify-center relative py-2 flex items-center border-2 border-gray-400 rounded-lg ">
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                </svg>
            </span>
            <span className="capitalize">
                {`${label}`} {isRequired && <span className="text-red-600">*</span>}
            </span>
                  {value && value !== '' && <span className="text-green-800">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                </svg>
            </span>}
            <input onChange={onChange} multiple={multiple} className="absolute hidden" type="file" name={name} id={id} accept={fileType} />
          </div>
      </label>
    </div>
  )
}


export function TextAreaInput({ isRequired, onChange, placeholder, defaultValue, name, id, label}) {
    return (
        <div className="mb-3">
            <div className="mb-2 relative">
              {label && <label className="text-sm font-fira font-normal" htmlFor={id}>{label} {isRequired && <span className="text-red-800 font-bold">*</span>}</label>}
              <textarea
                placeholder={placeholder}
                name={name} id={id}
                value={defaultValue}
                onChange={onChange}
                  className={`w-full py-3 mt-1 text-xs border-2 border-gray-300 rounded-lg focus:outline-blue-800 px-4`}
              ></textarea>
          </div>
        </div>
    )
}

